<ul class="snowflake-container">
  @for (item of snowFlakeElements; track $index) {
  <li class="snowflake"></li>
  }
</ul>
